// import "./AppointmentTypeIcon.css";
// import { ReactComponent as IconStayAndWait } from "../../assets/icons/stay-and-wait2.svg";
// import { ReactComponent as IconDropoff } from "../../assets/icons/drop-off.svg";
// import { ReactComponent as IconSelected } from "../../assets/icons/selected-check.svg";
// import { ReactComponent as IconStayAndWaitDisabled } from "../../assets/icons/stay-and-wait-disabled.svg";
//
// import { useMemo } from "react";
//
// export default function AppointmentTypeIcon({
//   selected,
//   handleClick,
//   isDropoff,
//   allowStayAndWait,
//   disabled,
// }) {
//   // Handler for our click
//   const handleButtonClicked = (e) => {
//     e.preventDefault();
//     if (handleClick && typeof handleClick === "function") {
//       handleClick(isDropoff);
//     }
//   };
//
//   const label = isDropoff ? "Drop Off Vehicle" : "Stay and Wait";
//   const description = isDropoff
//     ? "Leave your vehicle with us and we’ll reach out before any work begins."
//     : allowStayAndWait
//     ? "We’ll do our best to have you in and out in about an hour."
//     : "Stay and wait not available for your current service selections.";
//
//   const icon = useMemo(() => {
//     if (selected) {
//       return <IconSelected className="dropoff-svg-icon" />;
//     }
//     if (disabled)
//       return <IconStayAndWaitDisabled className="dropoff-svg-icon" />;
//     return isDropoff ? (
//       <IconDropoff className="dropoff-svg-icon" />
//     ) : (
//       <IconStayAndWait className="dropoff-svg-icon" />
//     );
//   }, [isDropoff, selected, disabled]);
//
//   return (
//     <button
//       className={`dropoff-option-card${selected ? " selected" : ""}`}
//       role="switch"
//       onClick={handleButtonClicked}
//       aria-checked={selected}
//       disabled={disabled}
//       aria-label={label}
//     >
//       <div className="card-content">
//         <div className="icon-wrapper">{icon}</div>
//         <div className="text-wrapper">
//           <span className="option-label">{label}</span>
//           {/* {selected && <p className="option-description">{description}</p>} */}
//           {<p className="option-description">{description}</p>}
//         </div>
//         {/* <div className="selection-indicator"> */}
//         {/*   {selected && <IconSelected className="check-icon" />} */}
//         {/* </div> */}
//       </div>
//     </button>
//   );
// }

import "./AppointmentTypeIcon.css";
import { ReactComponent as IconStayAndWait } from "../../assets/icons/stay-and-wait2.svg";
import { ReactComponent as IconDropoff } from "../../assets/icons/drop-off.svg";
import { ReactComponent as IconMobile } from "../../assets/icons/icons-directions.svg";
import { ReactComponent as IconSelected } from "../../assets/icons/selected-check.svg";
import { ReactComponent as IconStayAndWaitDisabled } from "../../assets/icons/stay-and-wait-disabled.svg";
import { useMemo } from "react";

export const APPOINTMENT_TYPES = {
  dropoff: {
    label: "Drop Off",
    description:
      "Leave your vehicle with us and we’ll reach out before any work begins.",
    Icon: IconDropoff,
  },
  waiter: {
    label: "Stay & Wait",
    description: "We’ll do our best to have you in and out in about an hour.",
    Icon: IconStayAndWait,
  },
  mobile: {
    label: "Mobile Repair",
    description: "We'll come to your home or office to perform the service.",
    Icon: IconMobile,
  },
  shuttle: {
    label: "Drop Off",
    description:
      "Leave your vehicle with us and we’ll reach out before any work begins.",
    Icon: IconDropoff,
  },
  ahdo: {
    label: "After Hours Drop Off",
    description:
      "Drop off your vehicle overnight and we will reach out before any work begins.",
    Icon: IconDropoff,
  },
};

export default function AppointmentTypeIcon({
  appointmentType,
  selected,
  handleClick,
  isDropoff,
  disabled,
}) {
  const handleClicked = (e) => {
    e.preventDefault();
    if (!disabled && handleClick) {
      handleClick(appointmentType);
    }
  };

  const config =
    APPOINTMENT_TYPES[appointmentType] || APPOINTMENT_TYPES.dropoff;

  const icon = useMemo(() => {
    if (selected) {
      return <IconSelected className="dropoff-svg-icon" />;
    }

    if (disabled) {
      return <IconStayAndWaitDisabled className="dropoff-svg-icon" />;
    }

    const { Icon } = config;
    return <Icon className="dropoff-svg-icon" />;

    // return isDropoff ? (
    //   <IconDropoff className="dropoff-svg-icon" />
    // ) : (
    //   <IconStayAndWait className="dropoff-svg-icon" />
    // );
  }, [selected, disabled, config]);

  const label = isDropoff ? "Drop Off" : "Stay & Wait";

  return (
    <button
      className={`dropoff-icon${selected ? " selected" : ""}`}
      role="switch"
      onClick={handleClicked}
      aria-checked={selected}
      disabled={disabled}
      // aria-label={isDropoff ? "Drop Off Vehicle" : "Stay and Wait"}
      aria-label={config.label}
    >
      <div className="dropoff-text-wrapper">
        <div>{icon}</div>
        <p className="dropoff-icon-label">{config.label}</p>
        <p className="dropoff-icon-text">{config.description}</p>
        {/* <p className="dropoff-icon-label"> */}
        {/*   {isDropoff ? "Drop Off" : "Stay & Wait"} */}
        {/* </p> */}
        {/* <p className="dropoff-icon-text"> */}
        {/*   {isDropoff */}
        {/*     ? "Leave your vehicle with us and we’ll reach out before any work begins." */}
        {/*     : "We’ll do our best to have you in and out in about an hour."} */}
        {/* </p> */}
      </div>
    </button>
  );
}
